export default __webpack_public_path__ + "9d5157815c727012809badb14760a324.svg";